export function isNonEmptyObject(
  object: Record<string, unknown> | undefined | null,
): object is Record<string, unknown> {
  return object != null && Object.keys(object).length > 0;
}
